import "./GridSetting.css"
import React, {useEffect, useRef, useState} from "react";
import { useConfig } from './ConfigContext';


const GridSetting = () => {
    const [gridSize, setGridSize] = useState(10);
    const [gridLength, setGridLength] = useState(100);
    const [gridCount, setGridCount] = useState(11);
    const [webglUrl, setWebglUrl] = useState("");
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setWebglUrl(config["webgl_url"]);
        }
    }, [config]);

    useEffect(() => {
        if (webglUrl && window.webglIframe) {
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_size', value: gridSize}, webglUrl);
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_length', value: gridLength}, webglUrl);
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_count', value: gridCount}, webglUrl);
        }
    }, [webglUrl]);

    useEffect(() => {
        if (webglUrl && window.webglIframe) {
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_size', value: gridSize}, webglUrl);
        }
    }, [gridSize]);

    useEffect(() => {
        if (webglUrl && window.webglIframe) {
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_length', value: gridLength}, webglUrl);
        }
    }, [gridLength]);

    useEffect(() => {
        if (webglUrl && window.webglIframe) {
            window.webglIframe.contentWindow.postMessage({type: 'webgl_set_grid_count', value: gridCount}, webglUrl);
        }
    }, [gridCount]);

    return (
        <div className="grid-slider-container">
            <h4 style={{ marginBottom: "15px" }}>Grid Settings</h4>
            <div style={{ marginBottom: "20px", flexDirection: "column"}}>
                <label>Grid Size: {gridSize}</label>
                <input
                    type="range"
                    min="1"
                    max="100"
                    value={gridSize}
                    onChange={(e) => setGridSize(parseFloat(e.target.value))}
                />
            </div>

            <div style={{ marginBottom: "20px" , flexDirection: "column"}}>
                <label>Grid Length: {gridLength}</label>
                <input
                    type="range"
                    min="10"
                    max="200"
                    value={gridLength}
                    onChange={(e) => setGridLength(parseFloat(e.target.value))}
                />
            </div>

            <div style={{ marginBottom: "20px" , flexDirection: "column"}}>
                <label>Grid Count: {gridCount}</label>
                <input
                    type="range"
                    min="6"
                    max="101"
                    step="2"
                    value={gridCount}
                    onChange={(e) => setGridCount(parseInt(e.target.value))}
                />
            </div>
        </div>
    );
};

export default GridSetting;
